// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Logo_cls1__SBcx1","cls2":"Logo_cls2__wZwIH","cls3":"Logo_cls3__mDdsm","cls4":"Logo_cls4__2M0CZ"};